import { render } from "./ImageDebugPanel.vue?vue&type=template&id=2977142a&scoped=true"
import script from "./ImageDebugPanel.vue?vue&type=script&lang=js"
export * from "./ImageDebugPanel.vue?vue&type=script&lang=js"

import "./ImageDebugPanel.vue?vue&type=style&index=0&id=2977142a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2977142a"]])

export default __exports__